export default {
  SENDING_RELEASE_NOTE: 'SENDING_RELEASE_NOTE',

};
